'use client';

import { useDialog } from '@react/chakra/core';
import { Image, Button, Dialog, Portal } from '@react/chakra';

import type { JSX } from 'react';

export function MomoButton(): JSX.Element {
  const { isOpen, onOpenChange } = useDialog();

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Trigger asChild>
        <Button
          w='160px'
          border={0}
          height='50px'
          bgPos='50% 0'
          color='white'
          fontWeight='bold'
          bgSize='400% 400%'
          transition='all .3s ease'
          bgGradient='linear-gradient(45deg, rgba(59,173,227,1) 0%, rgba(87,111,230,1) 25%, rgba(152,68,183,1) 51%, rgba(255,53,127,1) 100%)'
          _hover={{
            bgPos: '100% 0',
          }}
        >
          <Image
            h='50px'
            w='50px'
            objectFit='contain'
            alt='momo-icon.webp'
            src='/momo-icon.webp'
          />
          Momo me
        </Button>
      </Dialog.Trigger>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Body>
              <Image maxW='100%' src='/momo-qr.webp' alt='momo-qr.webp' />
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  );
}
